import { render, staticRenderFns } from "./collectCardError.vue?vue&type=template&id=031c20d9&scoped=true&"
import script from "./collectCardError.vue?vue&type=script&lang=js&"
export * from "./collectCardError.vue?vue&type=script&lang=js&"
import style0 from "./collectCardError.vue?vue&type=style&index=0&id=031c20d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c20d9",
  null
  
)

export default component.exports